import antdVi from 'antd/locale/vi_VN';
import viMessage from '../locales/vi_VN.json';

const viLang = {
    messages: { ...viMessage },
    antd: antdVi,
    locale: 'vi_VN'
}
export default viLang;
